<app-in-page-tabs *ngIf="tabs.length" [tabs]="tabs" />
